import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import { register } from './serviceWorker';

import { Tracker, TrackerProvider } from 'react-tracker'
import { clearCartLocal } from './products/actions/products.action';

import App from './App';
import store from './store';
import history from './utils/history';
// import './tracking/trackTimeSpentOnPage';
import setCustomPlaceSlugHeader from './utils/setCustomPlaceSlugHeader';
import tracker from './tracking/configureTracker';

// ── Google Translate ⇄ React crash guard ────────────────────────────────────────────
// Google Translate rewrites the page's text nodes (wraps them in <font> tags) via a
// MutationObserver, OUTSIDE of React's knowledge. When React later unmounts/reorders a
// subtree that Google has modified (e.g. the category bar, which we intentionally remount
// on switch to force re-translation), React calls removeChild/insertBefore on a node
// Google has already moved — the DOM throws "The node to be removed is not a child of this
// node", the error is uncaught, and the whole React tree crashes → the kiosk freezes and
// needs a reload. This is the well-known React issue #11538. Making the two DOM ops
// tolerant (return gracefully when the node isn't where React thinks) stops the crash
// without changing any normal behaviour — React never hits this path unless Google has
// mutated the DOM underneath it.
if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
            if (typeof console !== 'undefined') console.warn('[gtranslate-guard] skipped removeChild of a re-parented node', child);
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (typeof console !== 'undefined') console.warn('[gtranslate-guard] skipped insertBefore against a re-parented reference node', referenceNode);
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
}

// Chrome изстрелва "beforeinstallprompt" много рано — понякога преди React да се
// е монтирал. Хващаме го тук и го пазим, за да може банерът за добавяне на
// началния екран (src/common/AddToHomeScreen.js) да го използва по-късно.
window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    window.__a2hsPrompt = e;
    try {
        window.dispatchEvent(new Event('a2hs-prompt-captured'));
    } catch (err) { /* ignore */ }
});

// Register the tenant-aware PWA service worker, versioned by the build so a new
// deploy installs a fresh SW (?v changes) and drops stale per-tenant caches.
function registerCustomServiceWorker(version) {
    if (process.env.NODE_ENV !== 'production') return;
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker
        .register('/custom-sw.js?v=' + encodeURIComponent(version || '0'), { scope: '/' })
        .catch(function() { /* SW registration is best-effort */ });
}

// Version check - detect stale cached builds and auto-reload
(function checkAppVersion() {
    fetch('/version.json?_t=' + Date.now())
        .then(function(r) { return r.json(); })
        .then(function(data) {
            if (!data || !data.version) return;
            var stored = localStorage.getItem('app_build_version');
            localStorage.setItem('app_build_version', data.version);
            if (stored && stored !== data.version) {
                window.location.reload();
            }
            registerCustomServiceWorker(data.version);
        })
        .catch(function() {
            registerCustomServiceWorker('0');
        });
})();

// Backup: auto-reload on ChunkLoadError (script tag fails to load missing chunk)
window.addEventListener('error', function(e) {
    var target = e.target;
    if (target && target.tagName === 'SCRIPT' && target.src && target.src.includes('/static/js/')) {
        if (!sessionStorage.getItem('chunk_reload')) {
            sessionStorage.setItem('chunk_reload', '1');
            window.location.reload();
        }
    }
}, true);
// const tracker = new Tracker();

// setup();
// if(window.location.pathname) {
//     let placeSlug = window.location.pathname.split("/")[1];
//     if(placeSlug) {
//         setCustomPlaceSlugHeader(placeSlug);
//     }
// }
// if (Auth.getUserToken()) {
    // verifyToken(Utils.getUserToken())
    // .then((res) => {
    // })
    // .catch(e => {
    // })
// }
//


const app =
    <Provider store={store}>
        <BrowserRouter history={history}>
            <TrackerProvider tracker={tracker}>
                <App />
            </TrackerProvider>
        </BrowserRouter>
    </Provider>

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// register();
